import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import { Navigation } from 'swiper';
import { Thumbs } from 'swiper';
Swiper.use([Navigation, Thumbs]);

export function initSlider() {
  const speed = 500;
  const time = 10000;
  document.querySelectorAll('.slider-type-1').forEach(section => {

    const sliderVerticalsBG = new Swiper(section.querySelector('.slider-verticals__bg'), {
      speed: speed,
      allowTouchMove: false,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      watchSlidesProgress: true,
    });

    const sliderVerticalsInfo = new Swiper(section.querySelector('.slider-verticals__info-slider'), {
      speed: speed,
      enabled: false,
      allowTouchMove: false,
      autoplay: {
        delay: time,
        disableOnInteraction: false,
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      navigation: {
        nextEl: section.querySelector('.slider-verticals__next'),
        prevEl: section.querySelector('.slider-verticals__prev'),
      },
      thumbs: {
        swiper: sliderVerticalsBG,
      },
      controller: {
        control: sliderVerticalsBG,
      },
    });

    const sliderBullets = section.querySelectorAll('.slider-verticals__bullet');

    sliderBullets.forEach((element, index) => {
      element.addEventListener('click', function () {
        sliderBullets.forEach((element) => {
          element.classList.remove('active');
        });
        sliderVerticalsInfo.slideToLoop(index);
        this.classList.add('active');
      });
    });

    sliderVerticalsInfo.on('slideChange', function () {
      sliderBullets.forEach((element) => {
        element.classList.remove('active');
      });

      let activeSlide = sliderVerticalsInfo.realIndex;

      if (activeSlide < sliderBullets.length) {
        sliderBullets[activeSlide].classList.add('active');
      } else {
        activeSlide = sliderBullets.length - activeSlide;
        sliderBullets[activeSlide].classList.add('active');
      }

      gsap.fromTo(section.querySelector('.slider-verticals__progress .line'), {
        scaleX: 0
      }, {
        scaleX: 100 + '%',
        ease: 'none',
        duration: (time + speed) / 1000
      })
    });


    ScrollTrigger.create({
      trigger: section,
      start: 'top bottom-=40%',
      end: 'top bottom-=40%',
      once: true,
      onEnter: function () {
        sliderVerticalsInfo.enable();
        gsap.timeline()
          .fromTo(section.querySelector('.slider-verticals__progress .line'), {
            scaleX: 0
          }, {
            scaleX: 100 + '%',
            ease: 'none',
            duration: time / 1000
          })

      }
    })
  })
}


